<template>
    <main id="main">
      <Loading :isProcessing="isProcessing"></Loading>
      <DiagCorpHeader
        v-if="!isRendering && isAdminUser && !$route.meta.isAccountEdit"
        :corpName="dispCorpNm"
        :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
        :corporateSelectable="isAdmin || isSystemAdmin || isAllPermission"
        :manageCorpName="manageCorpName"
        :isAdmin="isAdmin"
        :isDiagAvailablePlan="isDiagAvailablePlan"
        @select-corporate="emitSelectCorpList"
      ></DiagCorpHeader>
      <div class="l-contents" v-if="!isRendering">
        <h1 class="l-pageTitle">
          <span class="l-pageLabel" v-if="$route.meta.isAccountEdit">アカウント情報</span>
          <span class="l-pageLabel" v-else>法人情報</span>
          基本情報
        </h1>
        <div v-if="this.isCheckManagedCorpCount">
          <!--div class="l-contentsBox"-->
            <div class="caution-block">
              <p class="caution-block__title">登録可能な企業の上限に達しています。</p>
              <div class="caution-block__body">
                <p>現在のプランで登録できる顧問先数は最大{{this.usagePlanList[this.managedUsagePlanId].maxCount}}社です。</p>
                <p v-if="this.managedUsagePlanId==2">スタンダードプラン利用者の場合は最大{{this.usagePlanList[1].maxCount}}社まで登録可能です。<br>
                  アップグレードをお希望の場合は診断協会までお問い合わせください。<br>
                  <a href="mailto:contact@roumu-kansa.jp">contact@roumu-kansa.jp</a>
                </p>
              </div>
            </div>
          <!--/div-->
        </div>
        <!-- isCheckManagedCorpCount -->
        <div v-else>
          <CorporateSideMenu :isNew="isNew"/>
          <div class="l-contentsBox">
            <table class="l-form-table">
              <tr>
                <th class="v-middle"><span>料金プラン</span></th>
                <td class="v-middle">
                  <div>
                    <template v-if="isAllPermission || isSystemAdmin">
                      <RadioButton v-model="$v.inputForm.$model.corporate.planId"
                        name="inputForm.corporate.planId"
                        :options="planList"
                        @input="emitChangePlan"
                        style="display: inline-block;"
                        ></RadioButton>
                      <ValidationErrorMessage v-show="$v.inputForm.corporate.planId.$error" validation="required" />
                    </template>
                    <template v-else-if="isAdmin">
                      <span style="padding-left: 20px;">{{ inputForm.corporate.plan.name }}</span>
                    </template>
                    <template v-else>
                      <span v-if="this.inputForm.corporate.plan" style="padding-left: 20px;">{{ this.inputForm.corporate.plan.name }}</span>
                    </template>
                    <span class="label trial" v-if="this.inputForm.corporate.trialEntry && this.inputForm.corporate.trialEntry.isDuringTrialPeriod">トライアル期間中</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th class="v-middle"><span>料金プラン(オプション)</span></th>
                <td class="v-middle">
                  <div>
                    <div v-if="(isAllPermission || isSystemAdmin) && inputForm.corporate.corpAuthNo == 3 && planOptionList.length > 0">
                      <template v-for="planOption in planOptionList">
                          <label class="l-checkbox" :key="planOption.planOptionId">
                            <input type="checkbox"
                              :value="planOption.planOptionId"
                              v-model="inputForm.corporatePlanOptions" />
                            {{ planOption.name }}
                          </label>
                      </template>
                    </div>
                    <div v-else>
                      <span style="padding-left: 20px;">{{ selectedPlanOptionLabel }}</span>
                    </div>
                  </div>
                </td>
              </tr>
<!--
              <tr>
                <th class="v-middle"><span>法人権限</span></th>
                <td class="v-middle">
                  <div v-if="isAllPermission || isSystemAdmin">
                    <RadioButton v-model="$v.inputForm.$model.corporate.corpAuthNo"
                      name="inputForm.corporate.corpAuthNo"
                      :options="selectCorpAuthList"
                      :disabled="isSystemAdminCorporate"
                      ></RadioButton>
                    <ValidationErrorMessage v-show="$v.inputForm.corporate.corpAuthNo.$error" validation="required" />
                  </div>
                  <div v-else-if="isAdmin">
                    <span style="padding-left: 20px;">{{ inputForm.corporate.corpAuthority.corpAuthNm }}</span>
                  </div>
                  <div v-else>
                    <span style="padding-left: 20px;">{{ this.inputForm.corporate.corpAuthority.corpAuthNm }}</span>
                  </div>
                </td>
              </tr>
-->

              <tr>
                <th class="v-middle"><span>法人権限</span></th>
                <td class="v-middle">
                  <div v-if="isAdmin || isAllPermission || isSystemAdmin">
                    <span style="padding-left: 20px;">{{ inputForm.corporate.corpAuthority.corpAuthNm }}</span>
                  </div>
                  <div v-else>
                    <span style="padding-left: 20px;">{{ selectedPlanOptionLabel }}</span>
                  </div>
                </td>
              </tr>

              <!-- 利用プラン　-->
              <tr v-if="this.isUsagePlanInput">
                <th class="v-middle"><span>利用プラン<em class="label-required">必須</em></span></th>
                <td>
                  <ValidationErrorMessage style="padding: 0 20px;" v-show="$v.inputForm.corporate.usagePlanId.$error" validation="required" />
                  <div class="l-radio-block">
                    <label class="l-radio">
                      <input type="radio" name="inputForm.corporate.usagePlanId" v-model="inputForm.corporate.usagePlanId" value = 0> {{this.usagePlanList[0].label}}
                    </label>
                  </div>
                  <div class="l-radio-block">
                    <label class="l-radio">
                      <input type="radio" name="inputForm.corporate.usagePlanId" v-model="inputForm.corporate.usagePlanId" value = 1> {{this.usagePlanList[1].label}}
                    </label>
                  </div>
                  <div class="l-radio-block">
                    <label class="l-radio">
                      <input type="radio" name="inputForm.corporate.usagePlanId" v-model="inputForm.corporate.usagePlanId" value = 2> {{this.usagePlanList[2].label}}
                    </label>
                  </div>
                </td>
              </tr>
              <tr v-if="this.isUsagePlanDisplay">
                <th class="v-middle"><span>利用プラン</span></th>
                <td class="v-middle"><span v-if="inputForm.corporate.usagePlanId!=null" style="padding-left: 20px;">{{this.usagePlanList[inputForm.corporate.usagePlanId].label}}</span></td>
              </tr>

              <tr v-if="this.isManagedCorpCountDisplay">
                <th class="v-middle"><span>登録法人数</span></th>
                <td class="v-middle"><span v-if="this.maxCount>0" style="padding-left: 20px;">{{ this.corpCount }} / {{ this.maxCount }}社</span></td>
              </tr>

              <tr v-if="inputForm.corporate.corpAuthNo != 9 || $route.meta.isAccountEdit">
                <th class="v-middle"><span>管理法人番号</span></th>
                <td class="v-middle">
                  <span v-if="!isNew" style="padding-left: 20px;">
                    <template v-if="inputForm.corporate.corpAuthNo == 3">{{ ((""+inputForm.corporate.corpId).length)>3?inputForm.corporate.corpId:('00'+inputForm.corporate.corpId).slice(-3) }}</template>
                    <template v-else>{{ ((""+inputForm.corporate.manageCorpId).length)>3?inputForm.corporate.manageCorpId:('00'+inputForm.corporate.manageCorpId).slice(-3) }}</template>
                  </span>
                </td>
              </tr>
              <tr v-if="inputForm.corporate.corpAuthNo == 9">
                <th class="v-middle"><span>顧問先番号</span></th>
                <td v-if="isAllPermission || isSystemAdmin" class="v-middle"><span style="padding-left: 20px;">{{ currentSubordinateNum }}</span></td>
                <td v-else class="v-middle">
                  <div class="l-inputAccount w-short">
                    <TextBox v-model="$v.inputForm.$model.corporate.subordinateNum" name="inputForm.corporate.subordinateNum"></TextBox>
                    <ValidationErrorMessage v-show="$v.inputForm.corporate.subordinateNum.$error && !$v.inputForm.corporate.subordinateNum.maxLength" validation="maxLength" valueLength="10" />
                    <ValidationErrorMessage v-show="$v.inputForm.corporate.subordinateNum.$error && !$v.inputForm.corporate.subordinateNum.customAlphaNum" validation="customAlphaNum" />
                  </div>
                </td>
              </tr>
              <tr>
                <th class="v-middle"><span>法人名<em class="label-required">必須</em></span></th>
                <td class="v-middle">
                  <div class="l-inputAccount">
                    <TextBox v-model="$v.inputForm.$model.corporate.corpNm" name="inputForm.corporate.corpNm"></TextBox>
                    <ValidationErrorMessage v-show="$v.inputForm.corporate.corpNm.$error" validation="required" />
                  </div>
                </td>
              </tr>
              <tr>
                <th class="v-middle"><span>法人名（ヨミガナ）<em class="label-required">必須</em></span></th>
                <td class="v-middle">
                  <div class="l-inputAccount">
                    <TextBox v-model="$v.inputForm.$model.corporate.furigana" name="inputForm.corporate.furigana"></TextBox>
                    <ValidationErrorMessage v-show="$v.inputForm.corporate.furigana.$error" validation="required" />
                  </div>
                </td>
              </tr>
              <tr>
                <th class="v-middle"><span>代表電話番号<em class="label-required">必須</em></span></th>
                <td class="v-middle">
                  <div class="l-inputAccount w-short">
                    <TextBox v-model="$v.inputForm.$model.corporate.telNo" name="inputForm.corporate.telNo"></TextBox>
                    <ValidationErrorMessage v-show="$v.inputForm.corporate.telNo.$error && !$v.inputForm.corporate.telNo.required" validation="required" />
                    <ValidationErrorMessage v-show="$v.inputForm.corporate.telNo.$error && !$v.inputForm.corporate.telNo.numeric" validation="numeric" />
                  </div>
                </td>
              </tr>
              <tr>
                <th><span>住所</span></th>
                <td>
                  <div class="l-inputAccount__set">
                    <span>郵便番号<em class="label-required">必須</em></span>
                    <div class="l-inputAccount w-vshort">
                      <TextBox v-model="$v.inputForm.$model.corporate.postCd" name="inputForm.corporate.postCd"></TextBox>
                    </div>
                  </div>
                  <ValidationErrorMessage style="margin-left:20px;" v-show="$v.inputForm.corporate.postCd.$error && !$v.inputForm.corporate.postCd.required" validation="required" />
                  <ValidationErrorMessage style="margin-left:20px;" v-show="$v.inputForm.corporate.postCd.$error && !$v.inputForm.corporate.postCd.numeric" validation="numeric" />
                  <ValidationErrorMessage style="margin-left:20px;" v-show="$v.inputForm.corporate.postCd.$error && !$v.inputForm.corporate.postCd.maxLength" validation="maxLength" valueLength="7" />

                  <div class="l-inputAccount__set">
                    <span>都道府県<em class="label-required">必須</em></span>
                    <div class="l-select w-auto">
                      <SelectBox v-model="$v.inputForm.$model.corporate.prefectureCd"
                        name="inputForm.corporate.prefectureCd"
                        :options="prefs"
                        :selectedValue="this.inputForm.corporate.prefectureCd"></SelectBox>
                    </div>
                  </div>
                  <ValidationErrorMessage style="margin-left:20px;" v-show="$v.inputForm.corporate.prefectureCd.$error" validation="required" />

                  <div class="l-inputAccount__set">
                    <span>市区町村・番地<em class="label-required">必須</em></span>
                    <div class="l-inputAccount">
                      <TextBox v-model="$v.inputForm.$model.corporate.address2" name="inputForm.corporate.address2"></TextBox>
                    </div>
                  </div>
                  <ValidationErrorMessage style="margin-left:20px;" v-show="$v.inputForm.corporate.address2.$error" validation="required" />

                  <div class="l-inputAccount__set">
                    <span>建物名・部屋番号など</span>
                    <div class="l-inputAccount">
                      <TextBox v-model="$v.inputForm.$model.corporate.address3" name="inputForm.corporate.address3"></TextBox>
                      <ValidationErrorMessage v-show="$v.inputForm.corporate.address3.$error && !$v.inputForm.corporate.address3.maxLength" validation="maxLength" valueLength="300" />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th class="v-middle"><span>担当者</span></th>
                <td class="v-middle">
                  <div class="l-inputAccount w-short">
                    <TextBox v-model="$v.inputForm.$model.corporate.responsibleName" name="inputForm.corporate.responsibleName"></TextBox>
                  </div>
                </td>
              </tr>
            </table>
            <CorporateFeatureInfoInput
              v-if="(isAdmin || isSystemAdmin || isAllPermission) && inputForm.corporate.corpAuthNo == 9"
              :corporateFeatureInfo="inputForm.corporate.corporateFeatureInfo"
              :planId="inputForm.corporate.planId"
              @change-feature-info="emitChangeFeatureInfo"
              ref="corporateFeatureInfoInput"
            ></CorporateFeatureInfoInput>
            <div class="l-contentsBox__bottom" style="text-align: center;">
              <div class="btn-basic is-inlne is-primary js-savebtn" @click="register()" :disabled="isProcessing"><a>保存</a></div>
            </div>
          </div>
        </div>
      </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import SelectBox from '@/components/parts/form/SelectBox.vue';
import RadioButton from '@/components/parts/form/RadioButton.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import constant from '@/const';
import { required, numeric, maxLength,requiredIf } from 'vuelidate/lib/validators';
import CorporateSideMenu from '@/components/parts/corporate/CorporateSideMenu.vue';
import CorporateFeatureInfoInput from '@/components/parts/corporate/CorporateFeatureInfoInput.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';

export default {
  name: 'CorporateInput',

  components: {
    Loading,
    TextBox,
    SelectBox,
    RadioButton,
    ValidationErrorMessage,
    CorporateSideMenu,
    CorporateFeatureInfoInput,
    DiagCorpHeader,
  },
  data() {
    return {
      inputForm: {
        corporate: {
          corpAuthNo: null,
          corpNm: '',
          furigana: '',
          postCd: '',
          prefectureCd: '',
          address2: '',
          address3: '',
          telNo: '',
          // useDiagType: null,
          // usageKbn: null,
          planId: null,
          corpAuthority: {
            corpAuthNm: ''
          },
          manageCorpId: null,
          plan: {
            name: '',
          },
          trialEntry: {
            // trialEntryConfirmDate: null,
            isDuringTrialPeriod: false,
          },
          corporateFeatureInfo: {},
          responsibleName: '',
          subordinateNum: null,
        },
        employees: {
          fixedTermEmployees: [],
          permanentEmployees: [],
        },
        attrItemsList: {
          basicAttrItems: [],
          workingHoursAttrItems: [],
          attendanceLogAttrItems: [],
          hrSystemAttrItems: [],
          retirementPayAttrItems: [],
          socialInsuranceAttrItems: [],
        },
        corporatePlanOptions: []
      },
      currentSubordinateNum: null,
      prefs: constant.PREFS,
      // useDiagTypeList: constant.USE_DIAG_TYPE,
      // usageKbnList: constant.USAGE_KBN,
      isProcessing: false,
      isAdmin: false,
      isSystemAdmin: false,
      isAllPermission: false,
      isDiagAvailablePlan: false,
      userAuthNo: '',
      corpAuthNo: '',
      dispCorpNm: '',
      planList: [
        {
          value: null,
          label: '',
          planOptions: [
            {
              planOptionId: null,
              name: ''
            }
          ]
        }
      ],
      planOptionList: [],
      planOptionIds: [],
      isRendering: false,
      corporateFeatureInfoLabels: [],
      selfCorpId: null,
      usagePlanList: [
        {
          value: null,
          label: '',
          maxCount: null,
        }
      ],
      corpCount: "",
      orgAccountClosingMonth:null,
    }
  },
  validations: {
    inputForm: {
      corporate: {
        planId: { required },
        corpNm: { required },
        furigana: { required },
        corpAuthNo: { required },
        postCd: { required, maxLength: maxLength(7), numeric },
        prefectureCd: { required },
        address2: { required },
        address3: { maxLength: maxLength(300) },
        telNo: { required },
        // useDiagType: { },
        // usageKbn: { },
        responsibleName: { },
        subordinateNum: { maxLength: maxLength(10), customAlphaNum: (value) => {
          return /^[A-Za-z0-9\-_]*$/.test(value)
        } },
        usagePlanId: {
          required: requiredIf(function () {
            return this.inputForm.corporate.planId==4 && this.inputForm.corporate.corpAuthNo == 3 && (this.isAllPermission || this.isSystemAdmin);
            // && this.inputForm.corporate.corpAuthNo!=9;
          })
        },
      }
    }
  },
  computed: {
    maxCount() {
      if ( this.inputForm.corporate.planId == 4 && this.inputForm.corporate.usagePlanId!=null ) {
        return this.usagePlanList[this.inputForm.corporate.usagePlanId].maxCount;
      }else {
        return 0;
      }
    },
    authNoList() {
      return this.$store.getters['auth/getCorpAuthMaster'];
    },
    selectCorpAuthList() {
      if (this.isNew) {
        return this.authNoList.filter(authNo => {
          if (authNo.value==9) return;
          if (!authNo.isCorporate) return;
          if (this.corpAuthNo < authNo.value) {
            return authNo;
          }
        });
      } else {
        return this.authNoList.filter(authNo => {
          if (authNo.value==9) return;
          if (!authNo.isCorporate) return;
          if (this.inputForm.corporate.corpAuthNo == this.corpAuthNo) {
            if (this.corpAuthNo <= authNo.value) {
              return authNo;
            }
          } else {
            if (this.corpAuthNo < authNo.value) {
              return authNo;
            }
          }
        });
      }
    },
    // 利用プラン入力権限
    isUsagePlanInput(){
        return this.planId == 4 && this.inputForm.corporate.corpAuthNo == 3 && (this.isSystemAdmin || this.isAllPermission);
//      return this.planId == 4 && (this.isSystemAdmin || this.isAllPermission);
    },
    // 利用プラン表示権限
    isUsagePlanDisplay(){
      return !this.isNew && this.planId == 4 && this.inputForm.corporate.corpAuthNo == 3 && this.isAdmin && this.corpId==this.selfCorpId;// && this.managedUsagePlanId != null;
    },
    // 登録企業数表示権限
    isManagedCorpCountDisplay(){
      return (!this.isNew && this.isUsagePlanInput) || this.isUsagePlanDisplay;
    },
    // 登録企業数チェック権限(遷移時)
    isCheckManagedCorpCount(){
      if ( this.managedPlanId != 4 || this.managedUsagePlanId == null) return false; 
      return this.isNew && this.managedPlanId == 4 && this.isAdminUser && this.inputForm.corporate.corpAuthNo == 9 && (this.managedCorpCount>=this.usagePlanList[this.managedUsagePlanId].maxCount);
    },
    // 登録企業数チェック権限(保存時)
    isCheckManagedCorpCountAtSave(){
      return !this.isNew && this.isUsagePlanInput && this.inputForm.corporate.usagePlanId !== null && (this.corpCount > this.usagePlanList[this.inputForm.corporate.usagePlanId].maxCount);
    },
    isCompany() {
      return this.inputForm.corporate.corpAuthNo == 9;
    },
    isSystemAdminCorporate() {
      return this.inputForm.corporate.corpAuthNo == 2;
    },
    corpId() {
      return this.$store.getters['user/getCorpId'];
    },
    isNew() {
      return this.$route.name === 'corporate-new';
    },
    planId() {
      return this.inputForm.corporate.planId;
    },
    selectedPlanOptionLabel() {
      if (this.inputForm.corporatePlanOptions.length == 0) {
        return '設定無し';
      }
      let planOptionList = this.planOptionList;
      let selectedPlanOptions = [];
      this.inputForm.corporatePlanOptions.forEach(planOptionId => {
        let selectedPlanOption = planOptionList.find(planOption => planOption.planOptionId === planOptionId);
        if (selectedPlanOption) selectedPlanOptions.push(selectedPlanOption.name);
      }, planOptionList);
      return selectedPlanOptions.length > 0 ? selectedPlanOptions.join(',') : '設定無し';
    },
    isAdminUser() {
      return this.userAuthNo == 3;  // 専門家ユーザのみ
    },
    isSelf() {
      return this.selfCorpId == this.corpId;
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
  },
  created: async function() {
    this.isRendering = true;
    this.isProcessing = true;

    await this.getCheckPlanOption();
    await this.getCorporate(this.corpId);
    await this.getCorporateFeatureInfoLabels(this.corpId);

    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isSystemAdmin = authority.isSystemAdmin;
    this.isAllPermission = authority.isAllPermission;
    this.isAdmin = authority.isAdmin;
    this.userAuthNo = authority.userAuthNo;
    this.corpAuthNo = authority.corpAuthNo;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;
    this.selfCorpId = authority.corpId;
    this.managedPlanId = authority.planId;
    this.managedUsagePlanId = authority.usagePlanId;
    this.managedCorpCount = authority.managedCorpCount;

    await this.getUsagePlanList();
    await this.getCorpCount();
    this.isProcessing = false;

    this.$nextTick(() => {
      this.isRendering = false;
    });
  },
  watch: {
    async planId() {
    },
    async corpId() {
      this.isRendering = true;
      this.isProcessing = true;

      await this.getCorporate(this.corpId);
      await this.getCorporateFeatureInfoLabels(this.corpId);
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    },
  },
  methods: {
    async getCorpCount() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/corporate/getManagedCorpCount', {
        corpId: this.corpId });
      if (res) {
        this.corpCount = res.data.corpCount;
      }
      this.isProcessing = false;
    },
    async getUsagePlanList() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/contact/trial_entry/getUsagePlanList');
      if (res) {
        let usagePlanList = [];
        res.data.usagePlanList.forEach(u => {
          usagePlanList.push({
            value: u.usagePlanId,
            label: u.name,
            maxCount: u.maxCount,
          });
        });
        this.usagePlanList = usagePlanList;
/*        if (this.manageUsagePlanId != null) {
          this.isCheckManagedCorpCount = this.managedPlanId == 4 && this.isAdmin && (this.managedCorpCount>=this.usagePlanList[this.managedUsagePlanId].maxCount);
        }else{
          this.isCheckManageCorpCoung = false;
        }*/
      }
      this.isProcessing = false;
    },
    async getCorporate(corpId) {
      let isNew = false;
      if (this.$route.name === 'corporate-new') {
        isNew = true;
      }
      let res = await this.$axios.post('/ld/api/corporate/getCorporate', {
        corpId: corpId,
        isNew: isNew,
      });
      if (res) {
        this.inputForm = {
          corporate: res.data.corporate,
          employees: res.data.employees,
          attrItemsList: res.data.attrItemsList,
          corporatePlanOptions: res.data.corporatePlanOptions,
        };
        this.currentSubordinateNum = res.data.corporate.subordinateNum;
        this.dispCorpNm = res.data.corporate.corpNm;
        let planList = [];
        res.data.planList.forEach(p => {
          planList.push({
            value: p.planId,
            label: p.name,
            planOptions: p.planOptions
          });
        });
        this.planList = planList;
        this.setPlanOptionList();
        // 決算月変更アラート表示のための処理
        this.orgAccountClosingMonth = res.data.corporate.corporateFeatureInfo.accountClosingMonth;
      }
    },
    async getCorporateFeatureInfoLabels(corpId) {
      let res = await this.$axios.post('/ld/api/corporate/getCorporateFeatureInfoLabels', {
        corpId: corpId,
      });
      if (res) {
        this.corporateFeatureInfoLabels = res.data.corporateFeatureInfoLabels;
      }
    },
    async getCheckPlanOption(){
      let res = await this.$axios.post('/ld/api/corporate/getCheckPlanOption');
      if(res){
        this.planOptionIds =  res.data.planOptionIds;
      }
    },
    async register() {
      // 料金プランが代理店以外のときは、代理店固有のデータをfalseでクリアする
      if (this.inputForm.corporate.planId != 3 ) this.setClearNotAgency();

      if (this.isCheckManagedCorpCountAtSave) {
        this.$toast.error('利用プランで登録できる法人数を超えてます。');
        return;
      }else{
        if (this.isValid()) {

          let accountClosingMonth = this.inputForm.corporate.corporateFeatureInfo.accountClosingMonth;
          if ( this.orgAccountClosingMonth!==null &&  accountClosingMonth!=null && this.orgAccountClosingMonth!=accountClosingMonth) {
            const answer = window.confirm("決算月を変更すると、人的資本の実績にずれが生じる場合があります。決算月を変更する際は診断協会にご相談ください。");
            if (!answer) return false;
          }

          this.isProcessing = true;
          // ログインユーザーがシステム管理者のときは管理ユーザ固定
//          if(this.corpAuthNo==2 ) this.inputForm.corporate.corpAuthNo=3;

          // 料金プランが労務サプリ以外のときはusagePlanIdをnullで初期化する
　        if ( this.inputForm.corporate.planId != 4 ) this.inputForm.corporate.usagePlanId = null;

          let res = await this.$axios.post('/ld/api/corporate/store', {
            corpId: this.corpId,
            corporate: this.inputForm.corporate,
            corporatePlanOptions: this.inputForm.corporatePlanOptions,
          });
          if (res.status === 200) {
            this.$toast.info('登録が完了しました');
            this.$store.dispatch('user/setCorpId', res.data.corporate.corpId);
            this.$store.dispatch('diag/setCorpId', res.data.corporate.corpId);
            this.dispCorpNm = res.data.corporate.corpNm;
            // 決算月変更アラート表示のための処理
            this.orgAccountClosingMonth = this.inputForm.corporate.corporateFeatureInfo.accountClosingMonth;

            await this.getCorporateFeatureInfoLabels(this.corpId);

            if (this.$route.name === 'corporate-new') {
              this.$router.push({ name: 'corporate-edit', query: { corpId: res.data.corporate.corpId } });
            }
          } else {
            this.$toast.error(res.data.message);
          }
          this.isProcessing = false;
        }else {
          this.$toast.error('入力データが不正です。');
        }
      }
    },
    isValid() {
      this.$v.$touch();
      let corporateFeatureInfoInputValidate = true;
      if ((this.isAdmin || this.isSystemAdmin || this.isAllPermission) && this.inputForm.corporate.corpAuthNo == 9) {
        this.$refs['corporateFeatureInfoInput'].$v.$touch();
        corporateFeatureInfoInputValidate = !this.$refs['corporateFeatureInfoInput'].$v.$invalid;
      }
      return !this.$v.$invalid && corporateFeatureInfoInputValidate
    },
    emitChangeEmployee(employeeForm) {
      this.inputForm.employees = employeeForm;
    },
    emitBasicAttrItems(basicAttrItems) {
      this.inputForm.attrItemsList.basicAttrItems = basicAttrItems.inputAttrItemList;
    },
    emitWorkingHoursAttrItems(workingHoursAttrItems) {
      this.inputForm.attrItemsList.workingHoursAttrItems = workingHoursAttrItems.inputAttrItemList;
    },
    emitAttendanceLogAttrItems(attendanceLogAttrItems) {
      this.inputForm.attrItemsList.attendanceLogAttrItems = attendanceLogAttrItems.inputAttrItemList;
    },
    emitHrSystemAttrItems(hrSystemAttrItems) {
      this.inputForm.attrItemsList.hrSystemAttrItems = hrSystemAttrItems.inputAttrItemList;
    },
    emitRetirementPayAttrItems(retirementPayAttrItems) {
      this.inputForm.attrItemsList.retirementPayAttrItems = retirementPayAttrItems.inputAttrItemList;
    },
    emitSocialInsuranceAttrItems(socialInsuranceAttrItems) {
      this.inputForm.attrItemsList.socialInsuranceAttrItems = socialInsuranceAttrItems.inputAttrItemList;
    },
    emitChangeFeatureInfo(param) {
      this.inputForm.corporate.corporateFeatureInfo = param.corporateFeatureInfo;
    },
    emitChangePlan: function () {
      let planOptionList = this.planOptionList;
      this.inputForm.corporatePlanOptions = this.inputForm.corporatePlanOptions.filter(planOptionId => {
        return planOptionList.some(planOption => planOption.planOptionId === planOptionId);
      });
      this.setPlanOptionList();
    },
    setPlanOptionList() {
      let plan = this.planList.find(p => p.value == 2); //社労士のプラン固定

      //let plan = this.planList.find(p => p.value == this.inputForm.corporate.planId);

      if (!plan) {
        this.planOptionList = [];
        return;
      }

      let pList=[];

      //料金プランによって料金プラン・オプションの表示を切り替える処理
      plan.planOptions.forEach(p=>{
          this.planOptionIds.forEach(po=>{
              if(po.plan_option_id==p.planOptionId){
                  if(this.inputForm.corporate.planId==1 )return; // 人事担当者
                  if(this.inputForm.corporate.planId==2 && po.is_display_price_plan2!=true )return; // 社労士で表示しない
                  if(this.inputForm.corporate.planId==3 && po.is_display_price_plan3!=true)return; // 代理店で表示しない
                  if(this.inputForm.corporate.planId==4 && po.is_ipo==true) {
                    return; // 労務サプリで表示しない
                  }
                  pList.push(p);
                  return;
              }
          });
      });

        this.planOptionList=pList;
      },
      async emitSelectCorpList(params) {
        this.$store.dispatch('user/setCorpId', params.corpId);
      },
      setClearNotAgency(){
        this.inputForm.corporate.corporateFeatureInfo['isIso45001'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isIso9001'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isIso9000Series'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isIso14000Series'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isIso14001'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isIso22000'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isIso22000Series'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isIso39001'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isHaccp'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isEcoAction21'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isEcoStage'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isGreenManagement'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isEnvironmentalPlanner'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isIsmsCert'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isSecurityAction'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isTrustEmark'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isPrivacyMark'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isSuperCert'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isBcpCert'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isResilienceCert'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isGMark'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isTransportationSafetyManagement'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isSafetyBus'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isBusinessContinuationAuthSystem'] = false;
        this.inputForm.corporate.corporateFeatureInfo['isGuidelineResilienceCert'] = false;
      }
    }
  }

</script>

